// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".action-button[data-v-6c93e4d0] {\n  max-width: var(--space-giga);\n}", "",{"version":3,"sources":["/home/danford/drochat/app/javascript/dashboard/components/widgets/modal/DeleteModal.vue"],"names":[],"mappings":"AACA;EACE,4BAAA;AAAF","file":"DeleteModal.vue","sourcesContent":["\n.action-button {\n  max-width: var(--space-giga);\n}\n"]}]);
// Exports
module.exports = exports;
